import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

export interface useOportunidadesLeadInterface {
  IdLead365: string;
  LeadCompartilhado?: boolean;
  PaginaAtual?: number;
  TotalItensRetorno?: number;
  PalavraChave?: string;
}

export function useOportunidadesLead(
  props: useOportunidadesLeadInterface & QueryGlobalInterface
) {
  const fetchData = async () => {
    const palavraChave = props.PalavraChave
      ? `palavraChave=${props.PalavraChave}&`
      : "";
    const OPORTUNIDADES_LEAD = `${backofficeEnviroment}/common/oportunidades-lead/v1/${props.IdLead365}?${palavraChave}PaginaAtual=${props.PaginaAtual}&TotalItensRetorno=${props.TotalItensRetorno}`;
    const response = await instance.get(OPORTUNIDADES_LEAD);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey, props.PaginaAtual],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: 0,
  });

  return query;
}
